import React, { useCallback, useEffect, useState } from 'react';
import style from './index.scss';
import { Button, Table, Modal, message, Spin } from 'antd';
import { TextComponent } from '../../trm/components/TableComponents';
import {
  CustomHeader,
  CustomHeaderMandatory
} from '../../trm/components/CustomHeaderComponent/customHeader';
import { toLower } from 'lodash';

const SegmentsListing = ({
  apiActions,
  customerTypeList,
  deleteCustomerTypeList,
  isLoading
}) => {
  const [visible, setVisible] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [editableField, setEditableField] = useState();
  const [deleteSegmentID, setDeleteSegmentID] = useState();
  const [disabledAddSegment, setDisabledAddSegment] = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [submitMode, setSubmitMode] = useState();
  const [errorMsg, setErrorMsg] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // Number of records per page

  useEffect(() => {
    apiActions?.getCustomerType();
  }, []);

  useEffect(() => {
    if (dataSource?.length > customerTypeList?.data?.length) {
      setDisabledAddSegment(true);
    } else {
      setDisabledAddSegment(false);
    }
  }, [dataSource]);

  useEffect(() => {
    if (deleteCustomerTypeList?.data === null || undefined) return;
    else {
      if (
        deleteCustomerTypeList?.data?.res?.status !== 200 &&
        deleteCustomerTypeList?.data?.res?.data?.msg !== undefined
      ) {
        message.error(deleteCustomerTypeList?.data?.res?.data?.msg);
      }
      if (deleteCustomerTypeList?.data?.res?.status === 200) {
        setEditableField();
        message.success('Segment deleted successfully');
      }
    }
  }, [deleteCustomerTypeList]);

  useEffect(() => {
    handleSegments(customerTypeList);
  }, [customerTypeList]);

  useEffect(() => {
    checkSaveDisabled();
  }, [dataSource]);

  useEffect(() => {
    if (errorMsg !== '' || null) {
      setIsSaveDisabled(true);
    }
  }, [errorMsg, isSaveDisabled]);

  const handleSegments = (customerTypeList) => {
    let segments = customerTypeList?.data;
    const segs = segments?.map((record) => {
      return {
        key: record.customer.id,
        segmentID: record.customer.id,
        name: record.customer.displayName,
        instancesUsed: record.numberOfInstances,
        isDeleted: false // Add the isDeleted property with a default value of false
      };
    });
    setDataSource(segs);
    setEditableField();
    setSubmitMode();
  };

  const handleAddSegment = () => {
    const newRow = {
      key: '-',
      segmentID: '-',
      name: '',
      instancesUsed: '-',
      productionUsed: '-'
    };
    setDataSource([newRow, ...dataSource]);
    setEditableField('-');
    setSubmitMode('ADD');
    setCurrentPage(1); // Reset current page to 1
  };

  const checkSaveDisabled = () => {
    if (!dataSource) {
      setIsSaveDisabled(true);
      return;
    }
    const isEdited = dataSource.some(
      (record) => record.segmentID === editableField || record.key === '-'
    );
    const isAdded = dataSource.some((record) => record.key === '-');
    const isDeleted = dataSource.some((record) => record.isDeleted);
    setIsSaveDisabled(!isEdited && !isAdded && !(isDeleted && !isAdded));
  };

  const columns = [
    {
      title: <CustomHeader title="Segment ID" />,
      className: style.bgWhite,
      key: 'scenario',
      width: '5%',
      render: (record) => {
        return (
          <TextComponent style={{ color: '#0C8ED7' }} id={record.segmentID} />
        );
      }
    },
    {
      title: <CustomHeaderMandatory title="Segment Display Name" />,
      className: style.bgWhite,
      key: 'name',
      width: '5%',
      // ...

      render: (text, record) => {
        if (record.segmentID === editableField) {
          return (
            <input
              style={{ width: '100%', height: '25px' }}
              value={record.name}
              onChange={(e) => {
                handleSegmentNameUpdate(e, record);
              }}
              onBlur={onBlurSegmentName}
              pagination={{
                current: currentPage,
                onChange: (page) => setCurrentPage(page)
              }}
              placeholder="Enter Segment Name"
              autoFocus // Add this attribute to focus the input field
            />
          );
        }
        return <TextComponent style={{ color: '#748AA1' }} id={record.name} />;
      }
    },
    {
      title: <CustomHeader title="No. of the Run instances used" />,
      className: style.bgWhite,
      key: 'scenario',
      width: '5%',
      render: (record) => {
        return (
          <TextComponent
            style={{ color: '#748AA1' }}
            id={record.instancesUsed}
          />
        );
      }
    },
    // {
    //   title: <CustomHeader title="Used in Production" />,
    //   className: style.bgWhite,
    //   key: 'scenario',
    //   width: '5%',
    //   render: (record) => {
    //     return (
    //       <TextComponent
    //         style={{ color: '#748AA1' }}
    //         id={record.isUsedInProduction ? 'Yes' : 'No'}
    //       />
    //     );
    //   }
    // },
    {
      title: <CustomHeader title="Action" />,
      className: style.bgWhite,
      key: 'scenario',
      width: '5%',
      render: (record) => {
        return (
          <div
            className={
              editableField === undefined ||
              null ||
              editableField !== record.segmentID
                ? style.Actions
                : style.ActionsDisabled
            }>
            <a
              onClick={() => {
                if (submitMode === 'ADD') {
                  handleEditEnabledField(record.segmentID);
                } else {
                  setSubmitMode('UPDATE');
                  handleEditEnabledField(record.segmentID);
                }
              }}
              style={{ color: '#748AA1', fontSize: '18px' }}>
              <i className="fa fa-edit" />
            </a>
            <a
              onClick={() => {
                setVisible(true);
                setDeleteSegmentID(record.segmentID);
              }}
              style={{ color: '#748AA1', fontSize: '18px' }}>
              <i className="fa fa-trash" />
            </a>
          </div>
        );
      }
    }
  ];

  const handleSave = useCallback(
    (mode) => {
      const name = dataSource
        ?.find(({ key }) => key === editableField)
        ?.name?.trim();

      if (!name) {
        message.error('Segment name cannot be blank');
        return;
      }

      const isDuplicate = customerTypeList?.data?.some(
        ({ customer }) => toLower(customer?.displayName) === toLower(name)
      );

      if (isDuplicate) {
        message.error('Segment name cannot be the same!');
        return;
      }

      const payload = { data: { name } };

      if (mode === 'UPDATE') {
        payload.data.id = editableField;
        apiActions?.putCustomerType(payload);
      } else {
        apiActions?.postCustomerType(payload);
      }
    },
    [dataSource, customerTypeList, editableField]
  );

  const handleEditEnabledField = (recordID) => {
    if (editableField == null) {
      setEditableField(recordID);
    } else if (editableField === recordID) {
      setEditableField();
    } else {
      setEditableField();
    }
  };

  const handleDeleteSegment = (segmentID) => {
    setVisible(false);
    apiActions.deleteCustomerType({ id: segmentID });
  };

  const handleSegmentNameUpdate = (e, record) => {
    const updatedValue = e.target.value;
    const newData = dataSource.map((item) =>
      item.key === record.key ? { ...item, name: updatedValue } : item
    );

    setDataSource(newData);
    validateSegmentName(updatedValue);
  };

  const validateSegmentName = (value) => {
    if (!value) {
      setErrorMsg('* Please input Segment Name.');
      setIsSaveDisabled(true);
      return;
    }

    if (!/^[^\s]+$/.test(value)) {
      setErrorMsg('*  Segment name cannot contain spaces.');
      setIsSaveDisabled(true);
      return;
    }

    if (!/^[^\s]{1,100}$/.test(value)) {
      setErrorMsg('* Segment Name must be less than 100 characters.');
      setIsSaveDisabled(true);
      return;
    }

    setErrorMsg('');
    setIsSaveDisabled(false);
  };

  const onBlurSegmentName = (e) => {
    if (!e.target.value) {
      setErrorMsg('* Please input Segment Name.');
      setIsSaveDisabled(true);
    }
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };

  return (
    <div className={style.listingWrapper}>
      <React.Fragment>
        <Spin spinning={isLoading}>
          <div className="">
            <div className={style.Listingheading}>
              <h3>Segments List</h3>
              <Button
                type="primary"
                id="AddSegment"
                onClick={handleAddSegment}
                disabled={disabledAddSegment}>
                Add New Segment
              </Button>
            </div>
            <Table
              className={style.table}
              columns={columns}
              dataSource={dataSource}
              scroll={{ y: 240 }}
              loading={false}
              rowKey="key"
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                onChange: (page) => setCurrentPage(page),
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '25', '50', '100'], // Options for number of records per page
                onShowSizeChange: (_, size) => handlePageSizeChange(size), // Callback when changing the page size
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} records` // Custom total count display
              }}
            />
          </div>
        </Spin>
      </React.Fragment>
      <Modal
        closable={false}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setVisible(false);
              setErrorMsg('');
            }}>
            Cancel
          </Button>,
          <Button
            key="confirm"
            type="primary"
            onClick={() => handleDeleteSegment(deleteSegmentID)}>
            Confirm
          </Button>
        ]}>
        {/* Modal content goes here */}
        <div style={{ display: 'flex' }}>
          <i
            className="fa fa-regular fa-exclamation-circle"
            style={{ color: '#ff0000', width: '20px', height: '20px' }}
          />
          <h2 style={{ fontSize: '15px' }}>Delete Segment</h2>
        </div>
        <p>Are you sure you want to delete this Segment?</p>
      </Modal>
      {errorMsg && <p style={{ color: 'red' }}>{errorMsg}</p>}
      <div className={style.footerButton}>
        <Button
          key="cancel"
          onClick={() => {
            handleSegments(customerTypeList);
            setEditableField();
            setErrorMsg('');
          }}
          disabled={!editableField}>
          Cancel
        </Button>
        <Button
          key="confirm"
          type="primary"
          onClick={() => {
            handleSave(submitMode);
          }}
          disabled={isSaveDisabled} // Disable the button if no edits or new segments
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default SegmentsListing;
